export default __webpack_public_path__ + "static/media/WaterPumpedIcon.7c7c40df.svg";